<template>
     <vs-dialog v-model="active" width="700px">
        <template #header>
          <h4 class="not-margin">
            Editar <b>Código de Sesión</b>
          </h4>
        </template>
        <div class="center content-inputs">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <label for="alias" class="pl-3 mr-1">Alias</label><i class='fas fa-shield-alt'></i>
                    <vs-input id="alias" placeholder="Alias" v-model="alias" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('alias')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                
                <vs-col sm="12" lg="4">
                    <label for="capacidad" class="pl-3 mr-1">Capacidad</label><i class='fas fa-shield-alt'></i>
                    <vs-input id="capacidad" type="number" v-model="capacidad" placeholder="Capacidad" class="pt-0" >
                        <template #message-danger v-if="errorFields.includes('capacidad')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>

                <vs-col sm="12" lg="4">
                    <label for="estatus" class="pl-3 mr-1">Estatus</label>
                    <vs-select id="estatus" filter placeholder="Estatus" v-model="estatus" :disabled="!listStatus.length" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('estatus')">
                            Requerido
                        </template>
                        <template v-if="listStatus.length">
                            <vs-option v-for="option in listStatus" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                                No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
                
                <vs-col sm="12" lg="4">
                    <label for="estudio" class="pl-3 mr-1">Plan de estudio</label>
                    <form autocomplete="off">
                        <vs-select id="planEstudio" filter placeholder="Plan de estudio" v-model="planEstudio" @input="listarAsignaturas" :disabled="!listPlanEstudio.length" :key="planId" class="pt-0">
                            <template #message-danger v-if="errorFields.includes('planEstudio')">
                                Requerido
                            </template>
                            <template v-if="listPlanEstudio.length">
                                <vs-option v-for="option in listPlanEstudio" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                            <vs-option label="No hay datos" :value="0">
                                No hay datos
                            </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                
                <vs-col sm="12" lg="4">
                    <label for="componente" class="pl-3 mr-1">Componente académico</label>
                    <vs-select id="componente" filter placeholder="Componente académico" v-model="componenteAcademico" :disabled="!listCompAcademico.length" class="pt-0">
                        <template #message-danger v-if="errorFields.includes('componenteAcademico')">
                            Requerido
                        </template>
                        <template v-if="listCompAcademico.length">
                            <vs-option v-for="option in listCompAcademico" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                                No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
                    
                <vs-col sm="12" lg="4">
                    <label for="asignatura" class="pl-3 mr-1">Campos formativos</label>
                    <form autocomplete="off">
                        <vs-select id="asignatura" filter placeholder="Campos formativos" v-model="campo_formativo" :disabled="!campos_formativos.length" :key="asignaturaId" class="pt-0">
                            <vs-option v-for="opciones in campos_formativos" :key="opciones.id"  :label="opciones.text" :value="opciones.id">
                                {{opciones.text}}
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('campo_formativo')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                
                <vs-col sm="12" lg="4">
                    <label for="asignatura" class="pl-3 mr-1">Asignatura</label>
                    <form autocomplete="off">
                        <vs-select id="asignatura" filter placeholder="Asignatura" v-model="asignatura" :disabled="!listAsignatura.length" :key="asignaturaId" class="pt-0">
                            <vs-option-group v-for="(grupo, g) in listAsignatura" :key="g">
                                <div slot="title">
                                    {{grupo.nombre}}
                                </div>
                                <vs-option v-for="(asignatura, a) in grupo.asignaturas" :key="a" :label="asignatura.nombre" :value="asignatura.id">
                                    {{asignatura.nombre}}
                                </vs-option>
                            </vs-option-group>
                            <template #message-danger v-if="errorFields.includes('asignatura')">
                                Requerido
                            </template>
                            <!-- <template v-if="listAsignatura.length">
                                <vs-option v-for="option in listAsignatura" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template> -->
                            <template v-else>
                            <vs-option label="No hay datos" :value="0">
                                No hay datos
                            </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label for="asignatura" class="pl-3 mr-1">Promedia</label>
                    <form autocomplete="off">
                        <vs-select id="asignatura" filter placeholder="Promedia" v-model="promedia" class="pt-0">
                            <vs-option-group>
                                <vs-option label="Si" value="si">
                                    Si
                                </vs-option>
                                <vs-option label="No" value="no">
                                    No
                                </vs-option>
                            </vs-option-group>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="orden_materia" class="pl-3 mr-1">Orden de materia</label>
                        <vs-input type="number" id="orden_materia" placeholder="Orden de materia" v-model="orden_materia" class="pt-0">
                            <template #message-danger v-if="errorFields.includes('orden_materia')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6" class="mt-1">
                    <form autocomplete="off">
                        <div class="d-flex">
                            <label for="orden_materia" class="pl-3 mr-1">¿Escala de calificación especificas? </label> 
                            <vs-tooltip>
                                <i class="fas fa-exclamation-circle"></i>
                                <template #tooltip>
                                    Si se selecciona una escala específica esta asignatura no se evaluará con la escala de calificación del componente académico sino con la que se seleccione en este momento
                                </template>
                            </vs-tooltip>
                        </div>
                        <vs-select id="asignatura" filter placeholder="Escala de calificación" v-model="escala_calificacion" class="pt-0">
                            <template #message-danger v-if="errorFields.includes('escala_calificacion')">
                                Requerido
                            </template>
                            <vs-option-group>
                                <vs-option label="Si" value="si">
                                    Si
                                </vs-option>
                                <vs-option label="No" value="no">
                                    No
                                </vs-option>
                            </vs-option-group>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col v-if="escala_calificacion == 'si'" sm="12" lg="6">
                    <label for="escalaEspecifica" class="pl-3 mr-1">Escala de calificación específica </label>
                    <form autocomplete="off">
                        <vs-select id="escalaEspecifica" filter placeholder="Escala de calificación específica" v-model="escala_especifica" :disabled="!escalas_especifica.length" :key="planId" class="pt-0">
                            <template #message-danger v-if="errorFields.includes('escala_especifica')">
                                Requerido
                            </template>
                            <vs-option v-for="option in escalas_especifica" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col v-if="escala_calificacion == 'si'" sm="12" lg="6" class="mt-1">
                    <form autocomplete="off">
                        <div class="d-flex">
                            <label for="orden_materia" class="pl-3 mr-1">¿Aplicar en periodos calculados sumatoria de periodos de entrada previos?
                            </label> 
                                <vs-tooltip>
                                    <i class="fas fa-exclamation-circle"></i>
                                    <template #tooltip>
                                        Al seleccionar <strong>"SI"</strong> los períodos calculados para este código de sesión, sumara los valores capturados en los periodos de entrada previos.
                                    </template>
                                </vs-tooltip>
                        </div>
                        <vs-select id="asignatura" filter placeholder="Seleccione una opción" v-model="aplicar_sumatoria_periodos_calculados" class="pt-0">
                            <template #message-danger v-if="errorFields.includes('aplicar_sumatoria_periodos_calculados')">
                                Requerido
                            </template>
                            <vs-option-group>
                                <vs-option label="Si" value="si">
                                    Si
                                </vs-option>
                                <vs-option label="No" value="no">
                                    No
                                </vs-option>
                            </vs-option-group>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col v-if="escala_calificacion == 'si'" sm="12" lg="6" class="mt-1">
                    <form autocomplete="off">
                        <label for="orden_materia" class="pl-3 mr-1">¿El código de sesión servira para capturar inasistencia?</label>
                        <div class="center d-flex justify-content-around mt-2">
                            <vs-radio v-model="capturar_inasistencia" val="si">
                                Si
                            </vs-radio>
                            <vs-radio v-model="capturar_inasistencia" val="no">
                                No
                            </vs-radio>
                        </div>
                        <div v-if="errorFields.includes('capturar_inasistencia')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">
                            Requerido
                        </div>
                    </form>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
            <div class="footer-dialog">
                <vs-button center @click="saveform()">
                    Guardar
                </vs-button>

                <div class="new">
                    Dudas? <a href="#">Ve el tutorial de esta sección</a>
                </div>
            </div>
        </template>
    </vs-dialog>
</template>

<script>
import catalogos from '../../../../../api/requests/catalogos.js'
import crns from '../../../../../api/requests/crns.js'
export default {
    props:[
        'value',
        'rowData',
        'institucion',
        'listCiclos',
        'listCompAcademico',
        'listStatus',
        'cicloEscolar',
        'programa',
        'escalas_especifica',
        'nivel',
        'grado'
    ],
    data () {
        return {
            alias: '',
            capacidad: '',
            estatus: '',
            componenteAcademico: '',
            planEstudio: '',
            asignatura: '',
            listAsignatura: [],
            listPlanEstudio: [],
            active: false,
            planId: (new Date()).getTime(),
            asignaturaId: (new Date()).getTime(),
            errorFields: [],
            rowId: null,
            promedia: '',
            orden_materia: '',
            escala_calificacion: '',
            escala_especifica: '',
            aplicar_sumatoria_periodos_calculados: '',
            campos_formativos: [
                {
                    id: 1,
                    text: 'Lenguajes'
                },
                {
                    id: 2,
                    text: 'Saberes y pensamiento científico'
                },
                {
                    id: 3,
                    text: 'Ética, naturaleza y sociedades'
                },
                {
                    id: 4,
                    text:'De lo humano y lo comunitario'
                },
                {
                    id: 5,
                    text:'Sin campo formativo'
                }
            ],
            campo_formativo: '',
            capturar_inasistencia: ''
        }
    },
    methods: {
        deafaultCampoFormativo(){
            if(this.campo_formativo == ''){
                if(this.nivel != 2){
                    this.campo_formativo = 5
                }else{
                    this.campo_formativo = ''
                }
            }
        },
        async listarPlanEstudios () {
            if (this.programa){
                try {
                    const { data: planesEstudio } = await catalogos.getPlanEstudios(this.programa)
                    this.listPlanEstudio = planesEstudio
                    this.planId = (new Date()).getTime()
                } catch (error) {

                }
            }else {
                this.listPlanEstudio = []
            }
        },
        async listarAsignaturas () {
            if (this.planEstudio){
                try {
                    this.listAsignatura = []
                    const vm = this
                    const { data: asignaturas } = await catalogos.getAsignaturas(this.planEstudio)
                    asignaturas.forEach(x => {
                        if(x.grado_id == vm.grado){
                            vm.listAsignatura.push(x)
                        }
                    })
                    this.asignaturaId = (new Date()).getTime()
                } catch (error) {
                        
                }
            }else {
                this.listAsignatura = []
            }
        },

        fillForm(row){
            this.rowId = row.id || null
            this.alias = row.alias || ''
            this.promedia = row.promedia
            this.capacidad = row.capacidad || ''
            this.estatus = row.status_crn || ''
            this.orden_materia = row.orden_materia || ''
            this.componenteAcademico = row.componente_academico_id || ''
            this.campo_formativo = row.campo_formativo_id ? row.campo_formativo_id : ''
            this.capturar_inasistencia = row.capturar_inasistencia ? row.capturar_inasistencia : ''
            this.planEstudio = row.asignatura instanceof Object &&
            row.asignatura.area_asignatura instanceof Object &&
            row.asignatura.area_asignatura.area instanceof Object && 
            row.asignatura.area_asignatura.area.plan_estudios_id 
            ? row.asignatura.area_asignatura.area.plan_estudios_id : ''
            
            this.escala_especifica = row.escala_calificacion_id || ''
            this.escala_calificacion = row.escala_especifica || ''
            this.aplicar_sumatoria_periodos_calculados = row.aplicar_sumatoria_periodos_calculados ? row.aplicar_sumatoria_periodos_calculados : ''
            this.listarPlanEstudios ()
            this.listarAsignaturas ()
            this.asignatura = row.asignatura_id || ''
            this.deafaultCampoFormativo()
        },
        async saveform() {
            try {
                const payload = this.sanityForm()
                if (payload) {
                    const response = await crns.updateCrn(payload)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Registro guardado`
                    })
                    this.$emit('refreshTable',true)
                    this.active = false
                }
            } catch (error) {
                console.error(error)
                this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `Algo salió mal`
                })
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
            }
            return false
        },
        modifyInfo(){
            if(this.escala_calificacion == 'no'){
                this.escala_especifica = ''
                this.aplicar_sumatoria_periodos_calculados = 'no'
                 this.capturar_inasistencia = 'no'
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.alias) {
                this.errorFields.push('alias')
            }
            if (!this.capacidad) {
                this.errorFields.push('capacidad')
            }
            if (!this.estatus) {
                this.errorFields.push('estatus')
            }
            if (!this.componenteAcademico) {
                this.errorFields.push('componenteAcademico')
            }
            if (!this.planEstudio) {
                this.errorFields.push('planEstudio')
            }
            if (!this.asignatura) {
                this.errorFields.push('asignatura')
            }
            if (!this.orden_materia) {
                this.errorFields.push('orden_materia')
            }
            if (!this.escala_calificacion) {
                this.errorFields.push('escala_calificacion')
            }
            if(!this.campo_formativo){
                this.errorFields.push('campo_formativo')
            }
            if(this.escala_calificacion == 'si'){
                if (!this.escala_especifica) {
                    this.errorFields.push('escala_especifica')
                }
                if (!this.aplicar_sumatoria_periodos_calculados) {
                    this.errorFields.push('aplicar_sumatoria_periodos_calculados')
                }
                if (!this.capturar_inasistencia) {
                    this.errorFields.push('capturar_inasistencia')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    crn_id: this.rowId,
                    alias: this.alias,
                    capacidad: parseInt(this.capacidad),
                    status_crn: this.estatus,
                    ciclo_escolar_id: this.cicloEscolar,
                    componente_academico_id: this.componenteAcademico,
                    programa_id: this.programa,
                    plan_id: this.planEstudio,
                    asignatura_id: this.asignatura,
                    institucion_id: this.institucion,
                    promedia: this.promedia,
                    orden_materia: this.orden_materia,
                    escala_especifica: this.escala_calificacion,
                    campo_formativo_id: this.campo_formativo,
                    aplicar_sumatoria_periodos_calculados: this.aplicar_sumatoria_periodos_calculados,
                    capturar_inasistencia: this.capturar_inasistencia
                }

                if(this.escala_calificacion == 'si'){
                    params.escala_calificacion_id = this.escala_especifica
                }else{
                    params.escala_calificacion_id = ''
                }
                return params
            } else {
                return null
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        rowData (val) {
            if (val instanceof Object){
                this.fillForm(val)
            }
        },
        programa(){
            this.listarAsignaturas()
        },
        fillForm(){
            this.cleanForm()
        },
        escala_calificacion(){
            this.modifyInfo()
        }
    }
}
</script>